import { gql } from '@apollo/client';
import { ReferralInfoShared } from '../fragments';

export default gql`
  query referral($id: ID) {
    referral(id: $id) {
      ...ReferralInfoShared
    }
  }
  ${ReferralInfoShared}
`;
